var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.406 3.73975H15.438C15.8289 3.73975 16.1457 4.05662 16.1457 4.44751V14.3562C16.1457 14.7471 15.8289 15.0639 15.438 15.0639H3.406C3.01512 15.0639 2.69824 14.7471 2.69824 14.3562V4.44751C2.69824 4.05662 3.01512 3.73975 3.406 3.73975Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06012 7.27856C6.35328 7.27856 6.59094 7.04091 6.59094 6.74774C6.59094 6.45458 6.35328 6.21692 6.06012 6.21692C5.76695 6.21692 5.5293 6.45458 5.5293 6.74774C5.5293 7.04091 5.76695 7.27856 6.06012 7.27856Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23706 9.40185L8.00646 10.8174L10.1297 8.34021L16.1457 12.9407V14.3562C16.1457 14.7471 15.8289 15.064 15.438 15.064H3.406C3.01512 15.064 2.69824 14.7471 2.69824 14.3562V12.9407L6.23706 9.40185Z",
    fill: "white",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOne);
export default __webpack_public_path__ + "static/media/upload-one.8186850f8e789a9af3f8f2c4fb63ebb2.svg";
export { ForwardRef as ReactComponent };